<div class="welcome-dialog" *ngIf="active">
  <div class="welcome-dialog__content">
    <button class="welcome-dialog__content__close" (click)="closeDialog()">
      <span class="material-icons">close</span>Close
    </button>
    <h2>
      {{
        user.firstName
          ? "Welcome to CONNECT, " + user.firstName + "!"
          : "Welcome to CONNECT!"
      }}
    </h2>
    <ng-container>
      <div class="">
        <div class="mb-10">
          <p>Welcome to CONNECT!</p>

          <p>
            We're excited to have you on board. To get started, please complete
            your profile, supported services, and service zones in the "My
            Account" section. This will help us better understand your
            capabilities and ensure smooth collaboration.
          </p>

          <p>Thank you for joining us!</p>
          <p>
            Best regards, <br />
            The CONNECT Team
          </p>
        </div>
        <div class="panelfields mt-30">
          <button
            type="submit"
            class="btn btn-default w-25"
            (click)="closeDialog()"
          >
            Close
          </button>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="welcome-dialog__background" (click)="closeDialog()"></div>
</div>
